if (!customElements.get('pa-community-pins')) {
 customElements.define('pa-community-pins',class extends HTMLElement {
  connectedCallback(){
   this.abort=new AbortController();const opts={signal:this.abort.signal};
   const pins=[...this.querySelectorAll('[data-community-pin]')];
   const mobile=matchMedia('(max-width: 767px)');
   let active=null,oldOverflow=null,moving=false;
   const unlock=()=>{if(oldOverflow!==null){document.documentElement.style.overflow=oldOverflow;oldOverflow=null;}};
   const states=new Map();
   const close=(pin,focus=false)=>{
    const s=states.get(pin);if(!s)return;
    moving=true;
    if(s.dialog.open)s.dialog.close();
    pin.append(s.panel);pin.open=false;s.summary.setAttribute('aria-expanded','false');
    if(active===pin){active=null;unlock();}
    moving=false;if(focus)s.summary.focus({preventScroll:true});
   };
   const present=(pin)=>{
    const s=states.get(pin);moving=true;
    if(mobile.matches){
     s.dialog.append(s.panel);
     if(!s.dialog.open){oldOverflow??=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';s.dialog.showModal();}
     s.panel.querySelector('[data-pin-close]').focus({preventScroll:true});
    }else{
     if(s.dialog.open)s.dialog.close();pin.append(s.panel);unlock();
     s.summary.focus({preventScroll:true});
    }
    moving=false;
   };
   pins.forEach(pin=>{
    const summary=pin.querySelector('summary'),panel=pin.querySelector('.pa-community-pin__panel');
    const dialog=document.createElement('dialog');dialog.className='pa-community-sheet';
    dialog.setAttribute('aria-label',summary.getAttribute('aria-label'));pin.append(dialog);
    states.set(pin,{summary,panel,dialog});
    const products=[...panel.querySelectorAll('[data-pin-product]')];let productIndex=0;
    const showProduct=next=>{if(!products.length)return;productIndex=(next+products.length)%products.length;products.forEach((product,index)=>product.hidden=index!==productIndex);const count=panel.querySelector('[data-pin-count]');if(count)count.textContent=`${productIndex+1} of ${products.length}`;};
    panel.querySelector('[data-pin-previous]')?.addEventListener('click',()=>showProduct(productIndex-1),opts);
    panel.querySelector('[data-pin-next]')?.addEventListener('click',()=>showProduct(productIndex+1),opts);
    summary.addEventListener('click',e=>{
     e.preventDefault();e.stopPropagation();
     if(pin.open){close(pin,true);return;}
     pins.forEach(p=>{if(p!==pin)close(p)});active=pin;showProduct(0);pin.open=true;summary.setAttribute('aria-expanded','true');present(pin);
    },opts);
    panel.querySelector('[data-pin-close]').addEventListener('click',e=>{e.preventDefault();e.stopPropagation();close(pin,true)},opts);
    dialog.addEventListener('cancel',e=>{e.preventDefault();close(pin,true)},opts);
    dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close(pin,true)},opts);
    pin.addEventListener('keydown',e=>{if(e.key==='Escape'&&pin.open){e.preventDefault();close(pin,true)}},opts);
   });
   document.addEventListener('click',e=>{if(active&&!active.contains(e.target))close(active)},opts);
   document.addEventListener('keydown',e=>{if(e.key==='Escape'&&active){e.preventDefault();close(active,true)}},opts);
   mobile.addEventListener('change',()=>{if(active)present(active)},opts);
   const track=this.querySelector('.pa-community__grid');let trackLeft=track?.scrollLeft||0;
   track?.addEventListener('scroll',()=>{if(Math.abs(track.scrollLeft-trackLeft)>1){if(active)close(active);trackLeft=track.scrollLeft;}},{...opts,passive:true});
   this.cleanup=()=>{if(active)close(active);states.forEach(s=>s.dialog.remove());unlock();};
  }
  disconnectedCallback(){this.cleanup?.();this.abort.abort()}
 });
}
